export default {"src":"/_next/static/media/goldClock.bad3188c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};